module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow == true),
      expression: "toastShow==true"
    }],
    staticClass: "toast",
    class: {
      top: _vm.position === 'top', middle: _vm.position === 'middle', bottom: _vm.position === 'bottom'
    }
  }, [(_vm.type === 'cancel') ? _c('span', {
    staticClass: "icon-cancel"
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'warn') ? _c('span', {
    staticClass: "icon-warn"
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.msg) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-52c19bfc"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = 68
// module chunks = 1